import React, { Component } from 'react';

export default class BudgetOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      title: undefined
    }
  }

  componentDidMount() {
    if (this.props.title !== undefined) {
      this.setState({
        amount: this.props.amount,
        title: this.props.title
      })
    }
  }

  render() {
    let style = {
      color: 'white',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '49%',
      margin: '10px'
    }
    return (
      <div style={style}>
        <p style={{ fontSize: '3em' }}>{displayCurrency(this.state.amount, 'EUR', 'de-DE')}</p>
        <p style={{ fontSize: '1em' }}>{this.state.title}</p>
      </div>
    );
  }
}
function displayCurrency(number, curr, locale) {
  if (locale === undefined) {
    locale = 'en-US';
  }
  if (curr === undefined) {
    curr = 'USD';
  }
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: curr,
  });

  return formatter.format(number);
}



// WEBPACK FOOTER //
// ./src/component/BudgetOverview.js